import * as yup from 'yup';
import { scopeSchema } from '../scopes/ScopeValidation';

export const agentSchema = yup.object().shape({
    scope: scopeSchema.required('Requis'),
    name: yup.string().required('Requis'),
    upn: yup.string().required('Requis'),
});